export default __webpack_public_path__ + "static/03-f811abbc6ea56239ba3320fa2bdaaf27.png";